import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/components/page/Login'
import Config from '@/components/page/Config'
import SettingDays from '@/components/page/SettingDays'
import SettingParameter from '@/components/page/SettingParameter'
import SettingWeeks from '@/components/page/SettingWeeks'
import Calculate from '@/components/page/Calculate'
import Result from '@/components/page/ShowResult'
import moreResult from '@/components/page/moreResult'
import User from '@/components/page/User'
import Implicit from '@/components/page/Implicit'
import NotFound from '@/components/page/NotFound'
import VueRouter from 'vue-router';
Vue.use(Router)

var basePath = '/dev/rst/';
if (process.env.ENV) {
	if ('production' != process.env.ENV) {
	  if ('local' == process.env.ENV) {
      basePath = '/';
    } else {
      basePath = '/' + process.env.ENV +'/rst/';
    }
	} else {
		basePath = '/rst/';
	}
}

const router =  new Router({
  mode: 'history',
  base: basePath,
  routes: [
    {
      path: '/',
      redirect: '/login'
    },{
      path:'/login',
      name:'Login',
      component:Login
    },{
      path:'/',
      name:'Config',
      component:Config,
      children:[
        /*{
          path:'',
          redirect: 'settingDays'
        },*/
        {
          path:'settingDays',
          name:'SettingDays',
          component:SettingDays
        },
        {
          path:'settingParameter',
          name:'SettingParameter',
          component:SettingParameter
        },{
          path:'settingWeeks',
          name:'SettingWeeks',
          component:SettingWeeks
        },{
          path:'calculate',
          name:'Calculate',
          component:Calculate
        },{
          path:'result',
          name:'Result',
          component:Result
        },{
          path:'moreResult',
          name:'moreResult',
          component:moreResult
        }
      ]
    },{
      path:'/user',
      name:'User',
      component:User
    },
    {
      path:'/implicit',
      name:'Implicit',
      component: Implicit
    },
    {
      path:'*',
      name:'NotFound',
      component:NotFound,
    }
  ]
})

export default router;






// WEBPACK FOOTER //
// ./src/router/index.js